import { render, staticRenderFns } from "./filtriMappatura.vue?vue&type=template&id=3090b8ec"
import script from "./filtriMappatura.vue?vue&type=script&lang=js"
export * from "./filtriMappatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports